import { logException } from "@wss/error-tracking";
import { toError } from "@wss/error-tracking/utils";
import { Accessory } from "~/common/Store/models/ProductListing";

const fetchAccessories = async (itemNumber: string): Promise<Accessory[]> => {
  const endpointUrl = "/api/productlisting/productaccessories";
  try {
    const result = await fetch(
      `${endpointUrl}?itemNumber=${encodeURIComponent(itemNumber)}`
    );

    return result.json<Accessory[]>();
  } catch (e) {
    const error = new Error("Error in fetchAccessories", {
      cause: toError(e),
    });

    await logException(error);

    return [];
  }
};
export default fetchAccessories;
